// Email subscribe block schema - Collect email subscribers from visitors
export const emailSubscribeSchema = {
  type: 'email-subscribe',
  label: 'Email Subscribe',
  description: 'Collect email subscribers from visitors',
  icon: 'UserPlus',
  defaultContent: {
    heading: 'Stay Updated',
    description: '',
    buttonText: 'Subscribe',
    showNameField: true,
    style: {},
  },
};
